import React from 'react'
import { SpawnComponentOnPipe } from '@morningtrain/react-spawner'
import AutoLogoutModal from 'widgets/modals/AutoLogoutModal'

export default function NotifyAboutLogoutOnPipe () {
  return (
    <SpawnComponentOnPipe component={(
      <AutoLogoutModal defaultOpen />
    )}
    />
  )
}
